import { AvailabilityRequest } from '../../model/availability/availability-request-model';
import { Availability } from '../../model/availability/availability';
import { LocalStorageService } from 'ngx-webstorage';
import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AvailabilityService } from '../../service/availability.service';
import { NotificationService } from '../../service/notification.service';
import { MatDialog } from '@angular/material/dialog';
import { AddServiceAddressComponent } from './../addserviceaddress/add-service-address.component';
import { DatePipe } from '@angular/common';
import { isSameDay, isSameMonth } from 'date-fns';
import { Observable, forkJoin, of, throwError } from 'rxjs';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { ProjectModel } from '../../model/availability/project-model';
import { ClientModel } from '../../model/availability/client-model';
import { catchError, finalize } from 'rxjs/operators';
import { timeValidator } from '../../common/time-validator';
import { DestroyComponent } from '../../common/destroy-component/destroy-component';

@Component({
  selector: 'app-availability',
  templateUrl: './availability.component.html',
  styleUrls: ['./availability.component.css'],
})
export class AvailabilityComponent extends DestroyComponent implements OnInit, OnChanges{
  @Input() selectedProviderId: string;
  @Input() minDateDays: number = 2;
  @Input() maxDateDays: number = 59;

  dataSource = [];
  slotList: Availability[];
  appoinementList: Availability[];
  providerAvailability: any = [];
  scheduledDates: any = [];
  typeNum: number;
  openCalender: boolean = false;
  availablityForm: FormGroup;
  appointmenTypes: Array<Object> = [{ num: 2, name: "In Clinic" }, { num: 3, name: "Telehealth" }, { num: 1, name: "In Home" }];
  timeZoneNumber: number;
  timeZones: Array<Object> = [
    { num: 1, name: "PST" },
    { num: 2, name: "CST" },
    { num: 4, name: "MST" },
    { num: 3, name: "EST" },
    { num: 5, name: 'AST' }
  ];
  availablityForms: FormArray;
  availabilityies: any = [];
  availabilityList: Availability[];
  availabilityRequest: AvailabilityRequest = new AvailabilityRequest();
  minDate: Date;
  maxDate: Date;
  serviceAddress: string[];
  clientsList: ClientModel[];
  projectList: ProjectModel[];
  isClientSelected: boolean = false;
  isLoading = true;

  constructor(public _availabilityService: AvailabilityService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private _notificationService: NotificationService,
    private _localStorage: LocalStorageService,
    public dialog: MatDialog) {

    super();
    this.minDate = new Date();
    this.maxDate = new Date();

    this.availablityForms = this.fb.array([]);
  }

  ngOnInit() {
    this.initializeDates();

    this.loadData(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['selectedProviderId'].firstChange) {
      this.loadData(true);
    }
  }

  initializeDates() {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + this.minDateDays);

    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + this.maxDateDays);
  }

  loadData(reloadAll: boolean) {
    this.isLoading = true;
    forkJoin({
      serviceAddress: this.serviceAddressLoadData(reloadAll),
      clients: this.clientsLoadData(reloadAll, this.selectedProviderId),
      availability: this.availabilityLoadData(),
      memberScheduledDates: this.memberScheduledDatesLoadData(),
    }).pipe(
      catchError(error => {
        this._notificationService.error(`An error occurred while loading data: ${error}. Please, try reloading the page.`);
        console.log(error);
        return of(null);
      }),
      finalize(() => {
        this.refreshScheduledDates();
        this.isLoading = false;
      })
    ).subscribe((results) => {
      this.processLoadDataResults(results)
    });
  }

  serviceAddressLoadData(reloadAll: boolean): Observable<any> {
    if (reloadAll || !this.serviceAddress) {
      return this._availabilityService.getProviderServiceAddress(this.selectedProviderId)
        .pipe(catchError(() => of(null)));
    } else {
      return of(null);
    }
  }


  clientsLoadData(reloadAll: boolean, selectedProviderId: string): Observable<any> {
    if (reloadAll || !this.clientsList) {
      return this._availabilityService.loadClients(selectedProviderId)
        .pipe(catchError(() => of(null)));
    } else {
      return of(null);
    }
  }

  memberScheduledDatesLoadData(): Observable<any> {
    return this._availabilityService
      .getSlotsDetailByProviderId(this.selectedProviderId)
      .pipe(catchError(() => of(null)));
  }

  availabilityLoadData(): Observable<any> {
    return this._availabilityService
      .getDefaultSlotsDetailByProviderId(this.selectedProviderId)
      .pipe(catchError(() => of(null)));
  }

  refreshScheduledDates() {
    this.scheduledDates = this.providerAvailability.filter(element => element.isLocked);
    if (this.availablityForms.length === 0) {
      this.addPreference();
    }
  }

  processLoadDataResults(results: any) {
    if (results.serviceAddress) {
      this.serviceAddress = results.serviceAddress.addresses;
    }
    if (results.clients) {
      this.clientsList = results.clients.clients;
    }
    if (results.availability) {
      this.providerAvailability = results.availability.availabilities;
    }
    if (results.memberScheduledDates) {
      this.procesMemberScheduledDatesResults(results)
    }
  }

  procesMemberScheduledDatesResults(results: any) {
    if (results.memberScheduledDates.appointments) {
      this.appoinementList = results.memberScheduledDates.appointments;
      this.appoinementList.forEach(appointment => {
        let dt = new Date(appointment.visitFromTime);
        dt.setMinutes(dt.getMinutes() + 60);
        let obj = {
          startDateTime: appointment.visitFromTime,
          endDateTime: dt,
          visitType: appointment.visitTypeId,
          timeZone: appointment.timezone,
          type: 'member_scheduled'
        }
        this.providerAvailability.push(obj);
      });
      this.providerAvailability = [...this.providerAvailability];
      this.openCalender = true;
    }
  }

  addPreference(): void {
    const formGroup = this.fb.group({
      clientId: [null],
      clientName: [null],
      projectId: [null],
      serviceAddress: [null,null],
      visitTypeId: [null, Validators.required],
      timeZone: [null, Validators.required],
      avaiDate: [null, Validators.required],
      startTime: [null, Validators.required],
      endTime: [null, Validators.required],
  }, { validator: timeValidator });

    // Add conditional validators
    formGroup.get('visitTypeId').valueChanges.subscribe(value => {
      const serviceAddressControl = formGroup.get('serviceAddress');
      const projectControl = formGroup.get('projectId');
      const clientControl = formGroup.get('clientId');
      if (value == '1') {
        serviceAddressControl.setValidators([Validators.required]);
      }else if (value == '2') {
        projectControl.setValidators([Validators.required]);
        clientControl.setValidators([Validators.required]);
      } else {
        serviceAddressControl.clearValidators();
        projectControl.clearValidators();
        clientControl.clearValidators();
      }
      serviceAddressControl.updateValueAndValidity();
      projectControl.updateValueAndValidity();
      clientControl.updateValueAndValidity();
    });

    this.availablityForms.push(formGroup);
  }

  resetFg() {
    this.availablityForms.clear();
    this.addPreference();
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.availablityForms.controls[controlName].hasError(errorName);
  }

  checkControlInvalidTouchedDirty(formGroup: FormGroup, controlName: string): boolean {
    const control = formGroup.get(controlName);
    return control && control.invalid && (control.dirty || control.touched);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(AddServiceAddressComponent, {
      panelClass: 'add-address-dialog-class',
      data: { providerId: this.selectedProviderId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadServiceAddress();
      }
    });
  }

  onRemoveRow(rowIndex: number) {
    this.availablityForms.removeAt(rowIndex);
  }

  AddPreferenceRecord(fg: FormGroup) {
    this.availablityForms.push(fg.value);
    this.availabilityies = fg.value;
  }

  submitRecords(availablityForms: FormArray): void {
    if (this.availablityForms.invalid) {
      // Trigger validation messages
      this.availablityForms.markAllAsTouched();
      this._notificationService.error('Please fill in all required fields.');
      return;
    }

    this.availabilityList = this.availablityForms.value.map((element) => {
      return {
        ...element,
        nursePractitionerId: this.selectedProviderId,
        fromDate: this.datePipe.transform(element.avaiDate[0], 'yyyy-MM-dd').toString(),
        toDate: this.datePipe.transform(element.avaiDate[1], 'yyyy-MM-dd').toString()
      };
    });

    const request: AvailabilityRequest = { availabilities: this.availabilityList, isProviderManager: true };
    this._availabilityService.saveAvailability(request)
      .pipe(
        finalize(() => {
          this.resetFg();
          this.loadData(false);
        }),
        catchError(error => {
          console.log(error);
          this._notificationService.error(`An error occurred while processing your request: ${error}. Please, try again.`);
          return throwError(error);
        })
      )
      .subscribe(
        (result) => {
          if (!result.successFlag) {
            this._notificationService.error(`Save Availability failed ${result.errorMessage}`);
          } else {
            this._notificationService.success('Saved Availability Data Successfully');
          }
          this.availablityForms.clear();
          this.addPreference();
        }
      );
  }

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  events: CalendarEvent[] = [];

  activeDayIsOpen: boolean = true;

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  checkInvalidTime(index: number): boolean {
    const fg = this.availablityForms.at(index) as FormGroup;
    return fg.hasError('invalidTime');
  }

  onSelecetionDateChange($event, index: number) {
    if (!$event || !$event[0] || !$event[1]) {
      return;
    }

    let startDate = $event[0].toJSON().split('T')[0];
    let endDate = $event[1].toJSON().split('T')[0];

    this.providerAvailability.forEach(element => {
      let availableDate = this.datePipe.transform(element.startDateTime, "yyyy-MM-dd");
      availableDate = availableDate === ("" || null) ? "" : availableDate.toString();

      if (availableDate === startDate && element.isLocked === true) {
        this._notificationService.success("Availability is locked for this day: " + startDate);
        this.availablityForms.at(index).get("avaiDate").patchValue("");
      }
    });
  }

  onClientSelectionChange(event, index): void {
    this.isClientSelected = true;
    this.availablityForms.at(index).get('projectId').patchValue(null);
    this._availabilityService.loadProjects(this.selectedProviderId, event.value)
      .subscribe(result => {
        if (!result) {
          return;
        }
        this.projectList = result.projects;
      });
  }

  private loadServiceAddress(): void {
    this.isLoading = true;
    this._availabilityService.getProviderServiceAddress(this.selectedProviderId)
      .subscribe(success => {
        if (success?.addresses) {
          this.serviceAddress = success.addresses;
        }
        this.isLoading = false;
      }, error => {
        console.log(error);
        this.isLoading = false;
      });
  }
}
